import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'

import { upsellableIntegrations } from 'modules/marketplace/components/Item/InstallWorkflow/UpsellModal/upsellableIntegrations'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

export const PAYROLL_CATEGORY_ID = '146390751'

const isIntegrationWithCustomPayrollLogic = (integrationDatoId: string) => {
  const customIntegrations = [
    integrationCodes.a3innuva.toString(),
    integrationCodes.a3nom.toString(),
    integrationCodes.datev_lauds_factorial.toString(),
    integrationCodes.zucchetti.toString(),
    integrationCodes.silae_fortify.toString(),
    integrationCodes.silae.toString(),
  ]
  return customIntegrations.includes(integrationDatoId)
}

export const usePaywall = (integration?: ItemIntegrationFragment) => {
  const { moduleAvailabilities } = useModuleAvailabilities()
  const upsellableIntegration = upsellableIntegrations[integration?.datoId || '']
  const { loading, featureAvailability } = useFeatureAvailability(upsellableIntegration?.id || '')

  if (!integration) return { showPaywall: false, loading: false }

  const shouldShowPaywall = () => {
    if (isIntegrationWithCustomPayrollLogic(integration.datoId)) {
      const hasPayrollModulesAvailable = moduleAvailabilities.some(
        (module) => ['payroll', 'compensations'].includes(module.id) && module.available
      )
      return !hasPayrollModulesAvailable
    }

    return !!upsellableIntegration && !featureAvailability.available
  }

  return {
    showPaywall: shouldShowPaywall(),
    loading: loading,
  }
}
